<template>
  <div class="owl-carousel owner-photos-slider">
    <div class="item-wrapper" v-for="(slide, index) in slides" :key="index">
      <div class="item">
        <img :src="slide.imageUrl" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "related-products-slider",
  props: ["data"],
  mounted() {
    $(document).ready(function() {
      $(".owner-photos-slider").owlCarousel({
        nav: true,
        // autoplay: true,
        responsive: {
          0: {
            items: 1
          },
          960: {
            items: 3
          }
        }
      });
    });
  },
  computed: {
    slides() {
      let slides = Object.values(JSON.parse(this.data));

      return slides.filter(slide => slide.mediaUrl != "");
    }
  }
};
</script>
